import styled from 'styled-components';
import { smallStyles } from '@luigiclaudio/ga-baseline-ui/typography';

const ProdcutItemSmall = styled.span`
    ${smallStyles}
    text-transform: uppercase;
`;

export default ProdcutItemSmall;
